<div class="growth-row">
   <div
      *ngIf="showHospitalName"
      class="growth-col growth-col1 fade-in">
      <h5>{{ hospitalRow?.practiceName }}</h5>
      <div class="goal-status">
         <ng-container *ngIf="getGoalsSummary().total > 0; else noGoals">
            <span
               [ngClass]="{
                  'growth-goalGreen': getGoalsSummary().met / getGoalsSummary().total > 0.5,
                  'growth-goalYellow': getGoalsSummary().met / getGoalsSummary().total === 0.5,
                  'growth-goalRed': getGoalsSummary().met / getGoalsSummary().total < 0.5
               }">
               <i
                  class="fa"
                  [ngClass]="{
                     'fa-face-smile': getGoalsSummary().met / getGoalsSummary().total > 0.5,
                     'fa-face-meh': getGoalsSummary().met / getGoalsSummary().total === 0.5,
                     'fa-face-frown': getGoalsSummary().met / getGoalsSummary().total < 0.5
                  }"
                  aria-hidden="true"></i>
               {{ getGoalsSummary().met }}/{{ getGoalsSummary().total }} Goals Met
            </span>
         </ng-container>
         <ng-template #noGoals>
            <span class="growth-goalGray">
               <i
                  class="fa fa-circle"
                  aria-hidden="true"></i>
               No Goals Set
            </span>
         </ng-template>
      </div>
   </div>

   <ng-container *ngFor="let kpi of kpis">
      <div
         *ngIf="kpiDataMap"
         class="growth-col fade-in">
         <vc-kpi-card
            *ngIf="hospitalRow?.practiceSKey"
            [practiceSKey]="hospitalRow?.practiceSKey"
            [kpiName]="kpi.kpiName"
            [currentValue]="kpiDataMap[kpi.kpiId]?.currentValue"
            [vetcorAvg]="kpiDataMap[kpi.kpiId]?.avgValue"
            [showChart]="showChart"></vc-kpi-card>
      </div>
   </ng-container>

   <div
      *ngIf="showMeeting"
      class="growth-col growth-col8 fade-in">
      <div class="growth-row">
         <div class="growth-upcoming-meeting">
            <a
               *ngIf="hospitalRow?.upcomingMeetingDate"
               href="#">
               <h6 class="title">Upcoming Meeting</h6>
            </a>
            <h6 *ngIf="hospitalRow?.upcomingMeetingDate">{{ hospitalRow?.upcomingMeetingDate | date : "M/d/yy | h:mm a" }}</h6>
            <span
               class="no-meetings"
               *ngIf="!hospitalRow?.upcomingMeetingDate">
               No Meetings Scheduled
            </span>
         </div>
         <div class="growth-last-meeting">
            <h6
               *ngIf="hospitalRow?.lastMeetingDate"
               class="title">
               Last Meeting
            </h6>
            <h6 *ngIf="hospitalRow?.lastMeetingDate">{{ hospitalRow?.lastMeetingDate | date : "M/d/yy" }}</h6>
            <span
               class="no-meetings"
               *ngIf="!hospitalRow?.lastMeetingDate">
               No Previous Meetings
            </span>
         </div>
         <a
            href="/growth-toolkit/regional-manager-summary/{{ hospitalRow?.practiceSKey }}"
            class="growth-toPractice-link">
            <div class="growth-toPractice">
               <i class="fa fa-chevron-right"></i>
            </div>
         </a>
      </div>
   </div>
</div>
